import { ICreateCourse } from '../../course/types';

export const COURSE_FORM_INITIAL_STATE: ICreateCourse = {
  title: '',
  tag: '',
  card_color: '',
  card_color_tag: '',
  slug: '',
};
